const DEFAULT_SETTINGS = {
  container: `slider__slide-changer`,
  item: `slider__slide-changer-item`,
  button: `slider__slide-changer-dot`,
  firstItemRootMod: `content__slider_start`,
  lastItemRootMod: `content__slider_end`,
  activeItemMod: `slider__slide-changer-item_active`,
}

const SlideChanger = class {
  constructor(container, slider, settingAttrs = DEFAULT_SETTINGS) {
    this.settings = Object.assign(Object.assign({}, DEFAULT_SETTINGS), settingAttrs);
    this.container = container;
    this.slider = slider;
    this.slides = this.slider.root.querySelectorAll(`.${this.slider.settings.item}`);
    this.changers = this.container.querySelectorAll(`.${this.settings.item}`);
  }

  init() {
    if (this.slides.length === this.changers.length) {
      for (let i = 0; i < this.slides.length; i++) {
        const button = this.changers[i].querySelector(`.${this.settings.button}`);
        if (button !== null) {
          button.addEventListener(`click`, this.slider.goTo(i));
        }
        const observer = new IntersectionObserver((entries) => {
          if (entries[0].intersectionRatio > 0.5) {
            this.changers[i].classList.add(this.settings.activeItemMod);
            if (entries[0].target === this.slides[0]) {
              this.slider.root.classList.add(this.settings.firstItemRootMod);
            }
            if (entries[0].target === this.slides[this.slides.length - 1]) {
              this.slider.root.classList.add(this.settings.lastItemRootMod);
            }
          } else {
            this.changers[i].classList.remove(this.settings.activeItemMod);
            if (entries[0].target === this.slides[0]) {
              this.slider.root.classList.remove(this.settings.firstItemRootMod);
            }
            if (entries[0].target === this.slides[this.slides.length - 1]) {
              this.slider.root.classList.remove(this.settings.lastItemRootMod);
            }
          }
        }, {threshold: 0.5});
        observer.observe(this.slides[i]);
      }
    } else {
      console.log(`Error: не верное число слайдов.`);
    }
  }
};

export default SlideChanger;
